import {
  Box,
  Button,
  Divider,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import dayjs from "dayjs";
import { COLORS } from "../../../constants/colors";
import { DeleteModal } from "../../../components/DeleteModal";
import { DeletePartyModal } from "./DeletePartyModal";
import { useState } from 'react';
import { BsShare } from "react-icons/bs";
import ShareModal from "../../../pages/invite-guest/components/ShareModal";
import ShareInviteLink from "../../../pages/invite-guest/components/ShareInviteLink";

export const PartyDetailsModal = ({props, forceUpdate}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const menuColor = useColorModeValue(COLORS.black, COLORS.white);

  const onShareOpen = () => setIsShareModalOpen(true);
  const onShareClose = () => setIsShareModalOpen(false);

  return (
    <Menu>
      <MenuButton>
        <BiDotsVerticalRounded size="1.5rem" />
      </MenuButton>
      <MenuList>
        <Box>
          <MenuItem color={menuColor} onClick={onOpen}>
            View Details
          </MenuItem>
          <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalBody borderRadius=".8rem">
                <Box my="30px">
                  <Flex align="center">
                    <Stack pl="10px">
                      <Text fontWeight="600" fontSize="1.2rem" >
                        {props.tenantName}
                      </Text>
                      <Text fontSize="md">
                        {props.phone}
                      </Text>
                      <Flex wrap="wrap" gap="0.6rem">
                        <Text px="5px" py="0.5" fontWeight="600" fontSize="12px">
                          Created: {dayjs(props.createdAt).format("DD/MMM/YYYY")}
                        </Text>
                        <Text px="5px" py="0.5" fontWeight="600" fontSize="12px">
                          Updated: {dayjs(props.updateAt).format("DD/MMM/YYYY")}
                        </Text>
                      </Flex>
                    </Stack>
                  </Flex>
                  <Divider />
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap="1rem"
                    bg="white"
                    p="5"
                    borderRadius="lg"
                    
                    border="1px"
                    borderColor="gray.200"
                  >
                    <Flex width="100%" justify="space-between">
                      <Text fontSize="sm">Number of Guests</Text>
                      <Text fontSize="md">
                        {props?.numberOfGuests}
                      </Text>
                    </Flex>
                    <Flex width="100%" justify="space-between">
                      <Text fontSize="sm">Date</Text>
                      <Text fontSize="md">
                        {dayjs(props?.dates).format("DD/MM/YYYY")}
                      </Text>
                    </Flex>
                    <Flex width="100%" justify="space-between">
                      <Text fontSize="sm">Address</Text>
                      <Text fontSize="md" maxW={"60%"}>
                        {props?.address}
                      </Text>
                    </Flex>
                    <Flex width="100%" justify="space-between">
                      <Text fontSize="sm">Description</Text>
                      <Text fontSize="md" maxW={"60%"}>
                        {props?.description}
                      </Text>
                    </Flex>

                    <Flex justify="space-between" align="center">
                      <Text fontSize="sm">Guest Code</Text>
                      <Text fontSize="md">
                        {props?.inviteCode || "--"}
                      </Text>
                    </Flex>
                    
                    <Flex justify="flex-end" mt={2}>
                      <Button
                        leftIcon={<BsShare />}
                        onClick={onShareOpen}
                        bg={COLORS.primary}
                        color="white"
                        size="sm"
                        _hover={{ opacity: 0.8 }}
                      >
                        Share Code
                      </Button>
                    </Flex>

                    <ShareModal
                      size="xs"
                      isOpen={isShareModalOpen}
                      onOpen={onShareOpen}
                      onClose={onShareClose}
                    >
                      <ShareInviteLink 
                        onClose={onShareClose} 
                        guestCode={props?.inviteCode} 
                      />
                    </ShareModal>
                  </Box>
                </Box>
              </ModalBody>
            </ModalContent>
          </Modal>
        </Box>
        <DeletePartyModal
          props={props}
          forceUpdate={forceUpdate}
          onClose={onClose}
        />
      </MenuList>
    </Menu>
  );
};
